import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import LoadingScreen from '../LoadingScreen';

const LazyRoute = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
};

export default LazyRoute;
